
<!-- TemplateBeginEditable name="hero" -->
<div class="dcf-hero dcf-hero-default">
  <!-- TemplateEndEditable -->
  <div class="dcf-hero-group-1">
    <div class="dcf-breadcrumbs-wrapper">
      <nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
        <!-- TemplateBeginEditable name="breadcrumbs" -->
        <ol>
          <li><a href="https://www.unl.edu/">Nebraska</a></li>
          <li><a href="/">TCAN / VITA Lincoln</a></li>
          <li><span aria-current="page">Schedule an Appointment</span></li>
        </ol>
        <!-- TemplateEndEditable -->
      </nav>
    </div>
    <header class="dcf-page-title" id="dcf-page-title">
      <!-- TemplateBeginEditable name="pagetitle" -->
      <h1>Schedule an Appointment</h1>
      <!-- TemplateEndEditable -->
    </header>
    <!-- TemplateBeginEditable name="herogroup1" -->
    <!-- TemplateEndEditable -->
  </div>
  <!-- TemplateBeginEditable name="herogroup2" -->
  <div class="dcf-hero-group-2">
  </div>
  <!-- TemplateEndEditable -->
</div>
<div class="dcf-main-content dcf-wrapper">


  <!-- Appointment Signup with no success -->
  @if (successMessage == '') {
    <div class="dcf-pb-7">
      @if (today.getTime() > taxDay.getTime()) {
        <div id="pastTaxDay">
          <h4>VITA appointments have ended for the {{ taxYear }} tax season. Check back in January 2027 to find out when appointments open for the {{ currentYear }} tax season.</h4>
          <h6>The IRS/Nebraska Department of Revenue filing deadline is April 15, 2026. If you need to submit an extension to file, you can fill out and submit <a href (click)="downloadForm4868()">Form 4868</a>.</h6>
        </div>
      }
      @if (today.getTime() < signupDay.getTime()) {
        <div id="beforeSignupDay">
          <h4>Tax appointments cannot yet be scheduled. Please check back on {{ timeToSignup }}.</h4>
        </div>
      }
      @if (today.getTime() < taxDay.getTime() && today.getTime() > signupDay.getTime()) {
        <div id="signup">
          <form
            #vitaSignupForm="ngForm"
            class="cmxform "
            id="vitaSignupForm"
            name="form"
            autocomplete="off"
            >
            <p class="dcf-mt-2 dcf-mb-3">Unsure if VITA can help you? <a href="/questionnaire" target="_blank">Click here to find out.</a></p>
            <p>The IRS/Nebraska Department of Revenue filing deadline is April 15, 2026. If you need to submit an extension to file, you can fill out and submit <a href (click)="downloadForm4868()">Form 4868</a>.</p>
            <p><b>NOTE: Please create a separate appointment for every tax return (i.e. multiple years or multiple individuals) that needs to be done.</b></p>
            <p>Appointments are for tax return preparation only. For already prepared tax returns or other questions, please email <a href="mailto:vita@unl.edu" target="_blank">vita&#64;unl.edu</a>.
            <br>For Facilitated Self-Assistance (FSA), please visit the FSA page by clicking <a href="/self_assist/" target="_blank">here</a> or clicking its link under the "Need Assistance" tab above.
          </p>
          
          <!-- @for (e of invalidFields | keyvalue; track e.key) {
            {{e.key}}: {{e.value}} <br />
          } -->

          <div id="steps_wrapper">
            <div id="steps_header">
              Book Your Tax Appointment with UNL VITA
            </div>
            <div class="steps">
              <div class="step active" data-step="resident">
                <fieldset aria-required="true">
                  <legend>
                    Are you a US Citizen, a permanent resident, or have you lived in the US for more than 5 years and are eligible to file as a resident?
                    <span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label for="resident_Yes">
                        Yes, I am a US Citizen, a permanent resident, or have lived in the US for more than 5 years and are eligible to file as a resident
                        <input type="radio" name="resident" id="resident_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['resident']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label for="resident_No">
                        No, I'm not a US Citizen, a permanent resident, or haven't lived in the US for more than 5 years
                        <input type="radio" name="resident" id="resident_No" value="No" (change)="validate()" [(ngModel)]="data['resident']" />
                      </label>
                    </div>
                  </div>
                </fieldset>
                <p class="cant-help-text error" [hidden]="data['resident'] == 'Yes' || data['resident'] == ''">
                  Please visit <a href="https://tcan.unl.edu/free-tax-help/international-students/">https://tcan.unl.edu/free-tax-help/international-students/</a> to get step by step guidance on how to prepare and file your non-resident tax return.
                </p>
              </div>

              <div class="step" data-step="appttype">
                <fieldset aria-required="true">
                  <legend>
                    Would you like an in-person appointment or virtual appointment over&nbsp;Zoom?<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label for="appttype_Yes">
                        I'd like an in-person appointment.
                        <input type="radio" name="appttype" id="appttype_Yes" value="inperson" (change)="validate()" [(ngModel)]="data['appttype']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label for="appttype_No">
                        I'd like a virtual appointment
                        <input type="radio" name="appttype" id="appttype_No" value="virtual" (change)="validate()" [(ngModel)]="data['appttype']" />
                      </label>
                    </div>
                  </div>
                </fieldset>
                <div [hidden]="data['appttype'] == 'inperson' || data['appttype'] == ''" class="cant-help-text">
                  <p class="cant-help-text error">
                    For our virtual appointments we've teamed up with GetYourRefund.org to help you file your taxes online with the help of certified VITA volunteers. 
                  </p>
                  <a href="https://getyourrefund.org/tcan" target="_NEW" class="button button__cta">Get started here</a>
                </div>
                 @if (data['appttype'] == 'inperson') {
                <div class="cant-help-text">
                  <p class="cant-help-text error">
                    In-person appointments for the 2025 tax year are now closed. Virtual appointments are still available at <a href="https://getyourrefund.org/tcan" target="_new">https://getyourrefund.org/tcan</a>.</p>
                  <p class="cant-help-text error">
                    If you feel you need an in person appointment please call our office at&nbsp;<a href="tel:4024720857" style="white-space: nowrap;">402-472-0857</a> or email us at&nbsp;<a href="mailto:vita@unl.edu">vita@unl.edu</a>. 
                  </p>
                </div>
                }
              </div>


              <div class="step" data-step="OldReturn">
                <fieldset aria-required="true">
                  <legend>
                    Do you need to file a return for any year earlier than 2023?<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, I need to file for years earlier than 2023
                        <input type="radio" name="OldReturn" id="OldReturn_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['OldReturn']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, I just need to file return(s) for one or more tax years between 2023-2025
                        <input type="radio" name="OldReturn" id="OldReturn_No" value="No" (change)="validate()" [(ngModel)]="data['OldReturn']" />
                      </label>
                    </div>
                  </div>
                </fieldset>
                <p class="cant-help-text error" [hidden]="data['OldReturn'] == 'No' || data['OldReturn'] == ''">VITA can only prepare tax returns for the previous 3 tax years for earlier years please contact our local TAS- Tax Payer Advocate Service to help you. Please visit <a href="https://apps.irs.gov/app/office-locator">https://apps.irs.gov/app/office-locator</a> to find an office.</p>
              </div>


              <div class="step" data-step="Amendment">
                <fieldset aria-required="true">
                  <legend>
                    Do you need to file an amendment (Changed) return for any year?<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, I need to file an amendment
                        <input type="radio" name="Amendment" id="Amendment_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['Amendment']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, this is for a new return
                        <input type="radio" name="Amendment" id="Amendment_No" value="No" (change)="validate()" [(ngModel)]="data['Amendment']" />
                      </label>
                    </div>
                  </div>
                </fieldset>
                <p class="cant-help-text error" [hidden]="data['Amendment'] == 'No' || data['Amendment'] == ''">Amendments can be completed once this tax season has concluded; you must have received your refund back to complete this process. To schedule an appointment for an amendment please reach out to our office at 402-472-0857 or email us at <a href="mailto:vita@unl.edu" target="_blank">vita@unl.edu</a>.</p>
              </div>

              <div class="step" data-step="crypto">
                <fieldset aria-required="true">
                  <legend>
                    Did you sell cryptocurrency during the year you're filing this return for?<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, my return involves selling cryptocurrency
                        <input type="radio" name="crypto" id="crypto_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['crypto']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, my return does not involve selling cryptocurrency
                        <input type="radio" name="crypto" id="crypto_No" value="No" (change)="validate()" [(ngModel)]="data['crypto']" />
                      </label>
                    </div>
                  </div>
                  
                </fieldset>
                <p class="cant-help-text error" [hidden]="this.data['crypto'] != 'Yes'">Due to IRS program guidelines, cryptocurrency cannot be handled by the VITA site.  Please contact a paid preparer for assistance.</p>
              </div>

              <div class="step" data-step="householdIncome">
                <fieldset aria-required="true">
                  <legend>
                    Did your household income for the year fall below $69,000?<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, my household income was below $69,000
                        <input type="radio" name="householdIncome" id="householdIncome_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['householdIncome']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, my household income was over $69,000
                        <input type="radio" name="householdIncome" id="householdIncome_No" value="No" (change)="validate()" [(ngModel)]="data['householdIncome']" />
                      </label>
                    </div>
                  </div>
                </fieldset>
                <p class="cant-help-text warn" [hidden]="data['householdIncome'] == 'Yes' || data['householdIncome'] == ''">VITA serves low to moderate income taxpayers if you feel you qualify for this service due to a change in income status or your income level is close to this threshold please continue.</p>
              </div>


              <div class="step" data-step="selfEmployment">
                <fieldset aria-required="true">
                  <legend>
                    Did you earn income from self-employment, gig work (Door dash, Uber, or own a small business?)<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, I earned income from self-employment or gig work 
                        <input type="radio" name="selfEmployment" id="selfEmployment_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['selfEmployment']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, I did not earn income from self-employment or gig work 
                        <input type="radio" name="selfEmployment" id="selfEmployment_No" value="No" (change)="validate()" [(ngModel)]="data['selfEmployment']" />
                      </label>
                    </div>
                  </div>
                </fieldset>

                <fieldset (aria-required)="data['selfEmployment'] === 'Yes'" class="collapsible" [class.is_open]="data['selfEmployment'] === 'Yes'">
                  <legend>
                    Was your business income under $35,000?<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, my business income was under $35,000
                        <input type="radio" name="busninessIncome" id="busninessIncome_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['busninessIncome']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, my business income was over $35,000
                        <input type="radio" name="busninessIncome" id="busninessIncome_No" value="No" (change)="validate()" [(ngModel)]="data['busninessIncome']" />
                      </label>
                    </div>
                  </div>
                  <p class="cant-help-text error" [hidden]="data['busninessIncome'] == 'Yes' || data['busninessIncome'] == ''">Please contact our office for more information as your return may be out of scope for VITA.</p>
                </fieldset>
                
                <fieldset (aria-required)="data['selfEmployment'] === 'Yes'" class="collapsible" [class.is_open]="data['selfEmployment'] === 'Yes'">
                  <legend>
                    Did you have employees, inventory, depreciation, or business losses?<span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, my business has employees, inventory, depreciation, or business losses
                        <input type="radio" name="busninessEmployees" id="busninessEmployees_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['busninessEmployees']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, my business does not have employees, inventory, depreciation, or business losses
                        <input type="radio" name="busninessEmployees" id="busninessEmployees_No" value="No" (change)="validate()" [(ngModel)]="data['busninessEmployees']" />
                      </label>
                    </div>
                  </div>
                  <p class="cant-help-text error" [hidden]="data['busninessEmployees'] == 'No' || data['busninessEmployees'] == ''">Please contact our office for more information as your return may be out of scope for VITA.</p>
                </fieldset>
              </div>


              <div class="step" data-step="contactInfo">
                <fieldset aria-required="true">
                  <legend>Contact Info</legend>
                  <div class="form_field">
                    <label class=" form-required" for="firstName">Legal First Name <span class="required_asterisk" aria-hidden="true">*</span></label>
                    <input type="text" class="dcf-input-text form-control" name="firstName" id="firstName" (keyup)="validate()" [(ngModel)]="data['firstName']" required>
                  </div>
                  <div class="form_field">
                    <label class=" form-required" for="lastName">Legal Last Name <span class="required_asterisk" aria-hidden="true">*</span></label>
                    <input type="text" class="dcf-input-text form-control" name="lastName" id="lastName" (keyup)="validate()" [(ngModel)]="data['lastName']" required>
                  </div>
                  <div class="form_field">
                    <label for="email">Email <span class="required_asterisk" aria-hidden="true">*</span></label>
                    <input type="email" class="dcf-input-text form-control" name="email" id="email" (change)="validate()" [(ngModel)]="data['email']" required>
                    <p class="dcf-txt-xs">A confirmation email will be sent to this email address.</p>
                  </div>
                  <div class="form_field">
                    <label class=" form-required" for="phone">Best Phone Number (where you we can call you) <span class="required_asterisk" aria-hidden="true">*</span></label>
                    <input type="tel" class="dcf-input-text form-control" name="phone" id="phone" (keyup)="validate()" [(ngModel)]="data['phone']" required placeholder="###-###-####">
                    <p class="dcf-txt-xs">If possible, please provide a number that allows the restricted caller function (*67)</p>
                  </div>
                  <div class="form_field">
                    <label class=" form-required" for="phone">Would you like to receive text/SMS, email, or both for reminders? <span class="required_asterisk" aria-hidden="true">*</span></label>
                    <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Send me reminders via text and email
                        <input type="radio" name="reminderType" id="busninessIncome_No" value="both" (change)="validate()" [(ngModel)]="data['reminderType']" />
                      </label>
                    </div>
                    <!-- <div class="radio_option">
                      <label>
                        Send me reminders via text/SMS only
                        <input type="radio" name="reminderType" id="busninessIncome_Yes" value="text" (change)="validate()" [(ngModel)]="data['reminderType']" />
                      </label>
                    </div> -->
                    <div class="radio_option">
                      <label>
                        Send me reminders via email only
                        <input type="radio" name="reminderType" id="busninessIncome_No" value="email" (change)="validate()" [(ngModel)]="data['reminderType']" />
                      </label>
                    </div>
                    
                  </div>
                    
                  </div>
                  <div class="form_field">
                    <label class=" form-required" for="bestTimeToCall">Best Time to Call <span class="required_asterisk" aria-hidden="true">*</span></label>
                    <input type="text" class="dcf-input-text form-control" name="bestTimeToCall" id="bestTimeToCall" (keyup)="validate()" [(ngModel)]="data['bestTimeToCall']" required>
                  </div>
                </fieldset>

                <fieldset>
                  <legend>
                    Did you have marketplace Health Insurance this year?
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, I have marketplace Health Insurance this year 
                        <input type="radio" name="marketplace" id="marketplace_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['marketplace']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, I did not have marketplace Health Insurance this year
                        <input type="radio" name="marketplace" id="marketplace_No" value="No" (change)="validate()" [(ngModel)]="data['marketplace']" />
                      </label>
                    </div>
                    <p class="cant-help-text error" [hidden]="data['marketplace'] == 'No' || data['marketplace'] == ''">Please bring your form 1095-A to your tax appointment.</p>
                  </div>
                </fieldset>


                <fieldset>
                  <legend>
                    What is your preferred language? <span class="required_asterisk" aria-hidden="true">*</span>
                    <br /><i style="font-weight: 400; font-size: 90%">
                      (We want to help everyone - our volunteers work in English, but we're happy to arrange a translator if you let us know ahead of time)
                    </i>
                    
                  </legend>

                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        English
                        <input type="radio" name="language" [id]="'languageEnglish'" [value]="'English'" (change)="validate()" [(ngModel)]="data['language']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        I would prefer a translator
                        <input type="radio" name="language" [id]="'languageOther'" [value]="'Other'" (change)="validate()" [(ngModel)]="data['language']" />
                      </label>
                    </div>
                    @if (data['language'] == 'Other') {
                       <div class="form_field" [hidden]="data['language'] != 'Other'" style="text-align: center;">
                        <label for="otherLanguage">Language: <span class="required_asterisk" aria-hidden="true">*</span></label>
                        <input type="text" class="dcf-input-text form-control" name="otherLanguage" id="otherLanguage" (keyup)="validate()" [(ngModel)]="data['otherLanguage']" style="margin: 0 auto;">
                        <p class="cant-help-text error" *ngIf="invalidFields['otherLanguage'] == true">Please provide your preferred language.</p>
                      </div>
                    }
                    <!-- @for (language of languageButtons; track language.label) {
                      <div class="radio_option">
                        <label>
                          {{language.label}} @if (language.label == 'Other') { (please specify) }
                          <input type="radio" name="language" [id]="'language'+language.label" [value]="language.value" (change)="validate()" [(ngModel)]="data['language']" />
                        </label>
                      </div>
                    }  -->

                    <!-- <div class="radio_option">
                      <label>
                        I would like a translator arranged for me
                        <input type="radio" name="translator" id="translator_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['translator']" />
                      </label>
                    </div> -->
                  </div>
                 
                  
                </fieldset>
                <!-- <fieldset aria-required="true">
                  <legend>
                    Do you need a translator?
                    <span class="required_asterisk" aria-hidden="true">*</span>
                  </legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Yes, I need a translator
                        <input type="radio" name="translator" id="translator_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['translator']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        No, I do not need a translator
                        <input type="radio" name="translator" id="translator_No" value="No" (change)="validate()" [(ngModel)]="data['translator']" />
                      </label>
                    </div>
                  </div>
                </fieldset>               -->
              </div>

              <div class="step" data-step="demographic">

                @if (!showDemographicFields ) {
                  <fieldset aria-required="true">
                    <legend>
                      Would you like to answer optional demographic questions?
                      <span class="required_asterisk" aria-hidden="true">*</span>
                    </legend>
                    <div class="options_row">
                      <div class="radio_option">
                        <label>
                          Yes, I'd like to answer optional demographic questions
                          <input type="radio" name="answerDemographic" id="answerDemographic_Yes" value="Yes" (change)="answerDemographic(true)" />
                        </label>
                      </div>
                      <div class="radio_option">
                        <label>
                          No, I'd prefer not to answer optional demographic questions
                          <input type="radio" name="answerDemographic" id="answerDemographic_No" value="No" (change)="answerDemographic(false)" />
                        </label>
                      </div>
                    </div>
                  </fieldset> 
                }

                @if (showDemographicFields ) {
                  <fieldset>
                    <legend>Demographic Questions (optional)</legend>
                    <div class="form_field">
                      <label for="householdPeople">How many people live in your household, including yourself?</label>
                      <input type="number" class="dcf-input-text form-control" name="householdPeople" id="householdPeople" (change)="validate()" min="1" max="20" [(ngModel)]="data['householdPeople']">
                      <p class="cant-help-text error" *ngIf="invalidFields['householdPeople'] == true">Please enter a number between 1 and 20.</p>

                    </div>
                    <div class="form_field">
                      <label for="dependents">How many dependents (children or others) do you plan to claim on your tax return?</label>
                      <input type="number" class="dcf-input-text form-control" name="dependents" id="dependents" (change)="validate()" min="0" max="20" [(ngModel)]="data['dependents']">
                      <p class="cant-help-text error" *ngIf="invalidFields['dependents'] == true">Please enter a number between 0 and 20.</p>
                    </div>
                    <div class="form_field">
                      <label class=""> 
                        What is your age?
                        <select name="age" (change)="validate()" [(ngModel)]="data['age']" class="dcf-input-select form-control">
                          <option value='Under 18'>Under 18</option>
                          <option value='18-24'>18-24</option>
                          <option value='25-39'>25-39</option>
                          <option value='40-59'>40-59</option>
                          <option value='60 or older'>60 or older</option>
                        </select>
                      </label>
                    </div>
                  </fieldset>

                  <fieldset aria-required="true">
                    <legend>
                      Do any of your dependents qualify for the Child Tax Credit (CTC) or Earned Income Tax Credit (EITC)?
                    </legend>
                    <div class="options_row">
                      <div class="radio_option">
                        <label>
                          Yes, one or more of my dependents qualify for CTC or EITC
                          <input type="radio" name="eitc" id="eitc_Yes" value="Yes" (change)="validate()" [(ngModel)]="data['eitc']" />
                        </label>
                      </div>
                      <div class="radio_option">
                        <label>
                          No, none of my dependents qualify for CTC or EITC
                          <input type="radio" name="eitc" id="eitc_No" value="No" (change)="validate()" [(ngModel)]="data['eitc']" />
                        </label>
                      </div>
                      <div class="radio_option">
                        <label>
                          I'm not sure if any of my dependents qualify for CTC or EITC
                          <input type="radio" name="eitc" id="eitc_NotSure" value="Not Sure" (change)="validate()" [(ngModel)]="data['eitc']" />
                        </label>
                      </div>
                    </div>
                  </fieldset> 

                  <fieldset aria-required="true">
                
                    <legend>
                      What is your race/ethnicity? (select all that apply)
                    </legend>
                    <div class="options_row">
                      @for (i of racesEthnicities; track i.label) {
                        <div class="radio_option">
                          <label>
                            {{i.label}}
                            <input type="checkbox" [name]="'raceEthnicity['+i.label+']'" [id]="'raceEthnicity'+i.label" [value]="i.value" (change)="validate()" [(ngModel)]="data['raceEthnicity'][i.label]" />
                          </label>
                        </div>
                      } 
                    </div>
                    @if (data['raceEthnicity'].Other != undefined) {
                    <div class="form_field" >
                      <label for="otherRaceEthnicity">Other:</label>
                      <input type="text" class="dcf-input-text form-control" name="otherRaceEthnicity" id="otherRaceEthnicity" (keyup)="validate()" [(ngModel)]="data['raceEthnicity']['otherRaceEthnicity']">
                      {{ data['raceEthnicity']['otherRaceEthnicity'] }}
                    </div>
                    }
                  </fieldset>  
                }           
              </div>


              <div class="step scheduler" data-step="scheduler">
                <fieldset>
                  <legend>Which city would you prefer your appointment to be in? <span class="required_asterisk" aria-hidden="true">*</span></legend>
                  <div class="options_row">
                    <div class="radio_option">
                      <label>
                        Grand Island
                        <input type="radio" name="city" id="city_gi" value="Grand Island" (change)="validate()" [(ngModel)]="data['city']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        Hastings
                        <input type="radio" name="city" id="city_hastings" value="Hastings" (change)="validate()" [(ngModel)]="data['city']" />
                      </label>
                    </div>
                    <div class="radio_option">
                      <label>
                        Lincoln
                        <input type="radio" name="city" id="city_lincoln" value="Lincoln" (change)="validate()" [(ngModel)]="data['city']" />
                      </label>
                    </div>
                  </div>
                </fieldset>
                @if (data['city'] != 'Grand Island') {
                <fieldset [hidden]="data['city'] == ''">
                  <legend>Select an available date below, then select an available location and time.</legend>
                  <app-appointment-picker
                        appointmentType="residential"
                        [city]="data['city']"
                        (dataChanged)="updateAppointmentData()"
                      ></app-appointment-picker>
                </fieldset>
                }
                @else {
                  <div class="vr_only">
                    <p>The {{data['city']}} site is not able to take in-person appointments currently, but we would still be happy to help you through our virtual tax preparation. We apologize for any inconvenience. </p>

                    <a href="https://getyourrefund.org/tcan" target="_NEW" class="button button__cta">Schedule Your Virtual Appointment Here</a>
                  </div>
                }
              </div>


              <!-- <div class="step" data-step="">
                
              </div> -->
            </div>

            <div class="stepnav">

              <div id="steps_submitting" *ngIf="submitting == true">Please wait...</div>
              <div *ngIf="submitting == false"><span class="required_asterisk" aria-hidden="true">*</span> Required field</div>   
              <button (click)="previousStep()" [disabled]="currentStep <= 1" id="previous_step" title="Previous Step">Previous Step</button>
              <input type="button"
                value="Submit"
                class="submit dcf-btn dcf-btn-primary dcf-mt-4"
                *ngIf="maxSteps == currentStep"
                (click)="storeAppointments($event)"
                [disabled]="nextStepDisabled || submitting" />
              <button (click)="nextStep()" [disabled]="nextStepDisabled" [hidden]="maxSteps == currentStep" id="next_step">Continue</button>
            </div>  
            <div id="steps_errors" [ngClass]="{'active': showFormErrors}">
              <div id="steps_errors_header">{{formErrorsHeader}} </div>
              @if (formErrors.length ) {
                <ul>
                  @for (e of formErrors | keyvalue; track e.key) {
                    <li [innerHTML]="e.value"></li>
                  }
                </ul>
              }
              <div *ngIf="resendToken" >
                <button (click)="resendConfirmationEmail()">Resend Confirmation Email</button>
              </div>
              <div *ngIf="resendTokenSent">Your confirmation email has been sent again!</div>
              <button (click)="showFormErrors = false" id="steps_errors_close">Hide Errors</button>
            </div>
          </div>
          </form>
        </div>
      }
    </div>
  }

  <!-- Successful Signup Screen -->
  @if (successMessage != '') {
    <div id="successfulSignupContent" class="dcf-mb-6">
      <div [innerHtml]="successMessage"></div>
      <div id="successfulSignupButtons" class="dcf-mt-4">
        <button type="button" class="dcf-btn dcf-btn-primary" onclick="window.print();">Print this Confirmation</button>
      </div>
    </div>
  }
</div>